import React from 'react';
import useCart from '~/hooks/useCart';

type PlatformProviderProps = {
  children: React.ReactElement | null;
};

export default function PersonalProvider({ children }: PlatformProviderProps) {
  useCart();

  return children;
}
